// extracted by mini-css-extract-plugin
export var completionBody = "_jm-2";
export var completionCard = "_jm-0";
export var completionFooter = "_jm-3";
export var completionTitle = "_jm-1";